import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseChartDirective } from 'ng2-charts';

import { SharedModule } from '@shared';
import { GeneAnalyticsRoutingModule } from './gene-analytics-routing.module';
import { GeneAnalyticsComponent } from './gene-analytics.component';

@NgModule({
  imports: [CommonModule, SharedModule, BaseChartDirective, GeneAnalyticsRoutingModule],
  declarations: [GeneAnalyticsComponent],
})
export class GeneAnalyticsModule {}
